<template>
    <section class="plugin-home-tabs-small-item" v-show="activeId === itemId">
        <div class="plugin-home-tabs-small-item__image">
            <plugin-home-image
                v-bind:image="image"
                v-bind:title="imageText"
                theme="gray"
            />
        </div>
        <div class="plugin-home-tabs-small-item__content">
            <div class="plugin-home-tabs-small-item__content-title" v-if="title">
                {{ title }}
            </div>
            <slot />
        </div>
    </section>
</template>

<script>
// import utils from '~/utils';

export default {
    name: 'plugin-home-tabs-small-item',
    props: {
        title: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        imageText: {
            type: String,
            default: '',
        },
        itemId: {
            type: String,
            default: '',
        },
        activeId: {
            type: String,
            default: '',
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-tabs-small-item {
    display: grid;
    grid-template-columns: 420px 1fr;
    gap: 24px;

    &__content {
        > *:not(:last-child) {
            border-bottom: 2px solid @color-gray-light-secondary;
        }
        &-title {
            .typography-landing-title();

            border-bottom: 0 !important;
        }
    }

    &__image {
        height: 330px;
    }

    @media @media-md-down {
        grid-template-columns: 1fr;
        gap: 12px;

        &__content {
            &-title {
                .typography-small();
            }
        }
    }
}
</style>
